import React, { useState } from 'react';
import './Contact.css';
import { CONTACT_INFO, GOOGLE_MAPS_EMBED } from '../config';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Mesajınız başarıyla gönderildi! Resume Çiğköfte ailesi olarak teşekkür ederiz.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2>Resume Çiğköfte ile İletişime Geçin</h2>
        <p className="subtitle">Sorularınız ve önerileriniz için bize ulaşın</p>
        
        <div className="contact-content">
          <div className="contact-left">
          <div className="contact-info">
            <div className="info-card">
              <h3>📍 Adres</h3>
              <p>{CONTACT_INFO.address.line1}</p>
              <p>{CONTACT_INFO.address.line2}</p>
            </div>
            
            <div className="info-card">
              <h3>📞 Telefon</h3>
              <p>{CONTACT_INFO.phone}</p>
              <p>{CONTACT_INFO.workingHours}</p>
            </div>
            
            <div className="info-card">
              <h3>📧 Email</h3>
              <p>{CONTACT_INFO.email}</p>
              <p>{CONTACT_INFO.emailOrder}</p>
            </div>
          </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleChange}
              required
            />
            
            <input
              type="email"
              name="email"
              placeholder="Email Adresiniz"
              value={formData.email}
              onChange={handleChange}
              required
            />
            
            <textarea
              name="message"
              placeholder="Mesajınız..."
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            
            <button type="submit" className="submit-button">Gönder</button>
          </form>
        </div>
        
        <div className="contact-map-wrapper">
          <div className="contact-map">
            <iframe
              width="100%"
              height="350"
              style={{ borderRadius: '15px', border: 'none' }}
              src={GOOGLE_MAPS_EMBED}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
